import { render, staticRenderFns } from "./QuickPayScoliosisPage.vue?vue&type=template&id=07ba3704&scoped=true"
import script from "./QuickPayScoliosisPage.vue?vue&type=script&lang=js"
export * from "./QuickPayScoliosisPage.vue?vue&type=script&lang=js"
import style0 from "./QuickPayScoliosisPage.vue?vue&type=style&index=0&id=07ba3704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ba3704",
  null
  
)

export default component.exports